export default __webpack_public_path__ + "static/media/icon-entrada.4f11cccb.svg";